import { RankingMark, WidgetKind, type WidgetOf } from 'corso-admin-ui';

const reasonDetails = [
  {
    kind: WidgetKind.sunburst,
    title: 'Reasons and their details',
    info: "Each reason splits into the details customers picked. A reason's grey part is its items with no detail, together with its smaller details when it has too many to show.",
    dimensions: ['reason', 'reasonDetail'],
    metric: 'items',
    otherLabel: 'Other reasons',
  },
  {
    kind: WidgetKind.ranking,
    mark: RankingMark.cloud,
    title: 'Reason details',
    info: 'The more items a detail was given for, the bigger it is drawn. A detail given under more than one reason is drawn once, with their items together.',
    dimension: 'reasonDetail',
    metric: 'items',
    limit: 40,
  },
] as const satisfies WidgetOf<'claimItems'>[];

export const returnReasonCharts = [
  {
    kind: WidgetKind.flow,
    title: 'Reason to resolution',
    info: 'Items with no resolution yet are left out.',
    dimensions: ['reason', 'resolution'],
    metric: 'items',
    otherLabel: 'Other reasons',
    hideUnset: true,
  },
  ...reasonDetails,
] as const satisfies WidgetOf<'claimItems'>[];

export const warrantyReasonCharts = [
  {
    kind: WidgetKind.flow,
    title: 'Product type to reason',
    info: 'Items with no product type are left out.',
    dimensions: ['productType', 'reason'],
    metric: 'items',
    otherLabel: 'Other product types',
    hideUnset: true,
  },
  ...reasonDetails,
] as const satisfies WidgetOf<'claimItems'>[];
